import React from "react";

export const TableWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => (
  <div className="gt-table-wrapper" {...props}>
    {children}
  </div>
);

export const Table = React.forwardRef<
  HTMLTableElement,
  React.TableHTMLAttributes<HTMLTableElement>
>(({ children, ...props }, ref) => (
  <table className="gt-table" ref={ref} {...props}>
    {children}
  </table>
));

export const TableHeader: React.FC = ({ children }) => (
  <thead className="gt-table-header">{children}</thead>
);

export const TableBody: React.FC = ({ children }) => (
  <tbody className="gt-table-body">{children}</tbody>
);

export const TableRow: React.FC<React.HTMLAttributes<HTMLTableRowElement>> = ({
  children,
  ...props
}) => <tr {...props}>{children}</tr>;

Table.displayName = "Table";
